<!-- Assign profile dialog -->
<p-dialog modal="true" styleClass="atlas-dialog-m" [(visible)]="showAssignProfileDialog">
  <ng-template pTemplate="header">
    <h4>
      {{ 'events.registration.management.create-profile.link-or-create-profile' | translate | titlecase }}
    </h4>
  </ng-template>
  <div class="mct-flex mct-row mct-justify-center mct-items-center">
    <wl-busy [show]="loadingProfile"></wl-busy>
  </div>
  <form #crudForm="ngForm" [hidden]="loadingProfile" autocomplete="off">
    <div class="dialog-body-container" *ngIf="assignProfileDialogInitialized">
      <div>{{ 'events.registration.management.create-profile.search-for-a-profile' | translate | ucfirst }}</div>
      <wl-profile-search-and-select
        *ngIf="showAssignProfileDialog"
        [selectButtonText]="'events.registration.management.create-profile.assign-profile'"
        [initialKeyword]="initialKeyword"
        (profileSelected)="assignProfileToRegistration($event.ProfileId)"
      >
      </wl-profile-search-and-select>
    </div>
  </form>
  <button pButton type="button" [disabled]="saving" (click)="createRegistrationProfile()" class="atlas-btn atlas-btn-primary mt-20">
    <wl-busy [show]="saving"> </wl-busy>
    {{ 'events.registration.management.create-profile.create-profile' | translate | titlecase }}
  </button>
</p-dialog>

<!-- Question Edit Registration dialog -->
<p-dialog modal="true" styleClass="atlas-dialog-s" [(visible)]="showQuestionEditRegistrationDialog">
  <p>
    {{ 'events.registration.management.create-profile.question-edit-registration' | translate }}
  </p>
  <ng-template pTemplate="footer">
    <div>
      <cancel-button [label]="'common.no' | translate | titlecase" (onClick)="closeQuestionEditRegistrationDialog()"> </cancel-button>
      <button
        pButton
        type="button"
        class="atlas-btn atlas-btn-primary"
        icon="pi pi-pencil"
        [label]="'common.yes' | translate | titlecase"
        (click)="goToRegistrationEdit()"
      ></button>
    </div>
  </ng-template>
</p-dialog>
